import { render } from "./Admin_userSection.vue?vue&type=template&id=8d259b5c"
import script from "./Admin_userSection.vue?vue&type=script&lang=js"
export * from "./Admin_userSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__